export default {
  "document": {
    "id": "7c26874c-d20b-4524-84cd-a3ec76e30d1a",
    "formType": "No docente",
    "fullName": "Bato gatindo",
    "rut": "26066368-2",
    "birthDate": "04/02/2014",
    "address": "Hochstetter 23",
    "city": "Temuco",
    "nationality": "Venezolano /A",
    "isStudent": "No",
    "email": "letty@febos.cl",
    "phoneNumber": "+56944332211",
    "institutionalEmail": "letty@febos.cl",
    "professionalTitle": "",
    "university": "UNIVERSIDAD ADOLFO IBÁÑEZ",
    "academicDegree": "Experto",
    "healthInsurance": "FONASA",
    "afp": "Cuprum",
    "serviceHours": 0,
    "schedules": [
      {
        "day": "",
        "hour": ""
      }
    ],
    "workHoursAndRemuneration": [
      {
        "subject": "",
        "subjectCode": "",
        "subjectName": "",
        "subjectCareer": "",
        "headOfCareer": "",
        "docentHours": 0,
        "collaboratorDocentHourAmountA": 0,
        "factorA": 0,
        "subtotalA": 0,
        "otherActivitiesHours": 0,
        "collaboratorDocentHourAmountB": 0,
        "factorB": 0,
        "subtotalB": 0
      }
    ],
    "serviceExpenseClassification": "Clasificación 2",
    "serviceProjectObjective": "",
    "serviceResult": "",
    "serviceExpenseCode": "",
    "contractValidityDate": [
      "09/02/2022",
      "18/03/2026"
    ],
    "contractValidityDateText": "Desde el 9 de febrero de 2022 hasta el 18 de marzo de 2026",
    "contractValidityDateStartText": "9 de febrero de 2022",
    "contractValidityDateEndText": "18 de marzo de 2026",
    "administrativeResponsible": "6198d467-9e80-4384-a5b5-285c8bd3fe98",
    "administrativeResponsibleComplete": {
      "id": "6198d467-9e80-4384-a5b5-285c8bd3fe98",
      "value": "6198d467-9e80-4384-a5b5-285c8bd3fe98",
      "label": "Daniel Olguin",
      "iut": "20833112-4",
      "position": "",
      "rol": "",
      "email": "daniel@febos.cl"
    },
    "administrativeResponsiblePosition": "cargo del responsable",
    "administrativeSupport": "401a546e-be90-437d-b424-db9f1e38e007",
    "otherResponsiblesCompleteNew": "79634866-9732-40f2-948a-253265c226f6",
    "otherResponsibleComplete": {
      "id": "79634866-9732-40f2-948a-253265c226f6",
      "value": "79634866-9732-40f2-948a-253265c226f6",
      "label": "Catalina",
      "iut": "76245362-2",
      "position": "convencional",
      "rol": "",
      "email": "ninosca+cata@febos.cl"
    },
    "administrativeSupportComplete": {
      "id": "401a546e-be90-437d-b424-db9f1e38e007",
      "value": "401a546e-be90-437d-b424-db9f1e38e007",
      "label": "Alvaro Patricio Alvarez Olivares",
      "iut": "16576014-K",
      "position": "Desarrolloo",
      "rol": "",
      "email": "alvaro@febos.cl"
    },
    "otherResponsibles": "",
    "specificLaborArray": [
      {
        "task": "labor uno"
      },
      {
        "task": "labor dos"
      }
    ],
    "dependencyUnit": "Adquisiciones",
    "totalAmount": 1200,
    "totalAmountText": "MIL DOSCIENTOS",
    "paymentPeriod": "Periodo 1",
    "contractPaymentPeriod": "Mensual",
    "paymentPeriodBreakdown": [
      {
        "description": "test",
        "amount": 1200,
        "project": "Fuente 1",
        "responsibilityCenter": "Centro 1"
      }
    ],
    "travelAllowance": false,
    "travelAllowanceJustification": "",
    "landPassageRefund": false,
    "landPassageRefundJustification": "",
    "training": false,
    "trainingJustification": "",
    "experience": "test",
    "expertise": "experticia",
    "weeklyHours": 0,
    "associatedProduct": [
      {
        "product": "mi servicio",
        "subproduct": "medio de verificacion",
        "period": "Marzo 2025",
        "bruteValuation": 1200
      }
    ],
    "confirmEmail": "letty@febos.cl",
    "title": "Psicologo/a",
    "contractValidityDateStart": "2022-02-09T03:00:00.000Z",
    "contractValidityDateEnd": "2026-03-18T03:00:00.000Z",
    "isDocenteForm": false,
    "isNotDocenteForm": true,
    "attachments": [
      {
        "id": "54fb57d1-be75-40d8-a818-5eedf6f4d0f4",
        "archivoId": "54fb57d1-be75-40d8-a818-5eedf6f4d0f4",
        "name": "GRC - N° 18 - 24-06-2025 15:23:40.pdf",
        "source": "repositorio",
        "origen": "experiencia",
        "tipo": "repositorio",
        "currentDescription": "GRC - N° 18 - 24-06-2025 15:23:40.pdf",
        "mime": "application/pdf",
        "date": "2025-06-24 15:23:58",
        "path": "escritorio-digital/chile/desarrollo/repositorios/bf335486-9031-4ca5-a06f-19309ea73a56/54fb57d1-be75-40d8-a818-5eedf6f4d0f4",
        "failed": false
      },
      {
        "id": "9ed98ed0-0e95-11f1-8047-e7c13ea114ef",
        "name": "tetete.pdf",
        "currentDescription": "tetete.pdf",
        "mime": "application/pdf",
        "date": "2026-02-20 16:02:02",
        "path": "febos-io/chile/escritorio-digital/desarrollo/archivos/expedientes/17716171203179ed98ed0-0e95-11f1-8047-e7c13ea114ef.pdf",
        "failed": false,
        "origen": "expertise"
      },
      {
        "id": "e7bc2860-0e95-11f1-8047-e7c13ea114ef",
        "name": "rif.pdf",
        "currentDescription": "rif.pdf",
        "mime": "application/pdf",
        "date": "2026-02-20 16:02:04",
        "path": "febos-io/chile/escritorio-digital/desarrollo/archivos/expedientes/1771617242598e7bc2860-0e95-11f1-8047-e7c13ea114ef.pdf",
        "failed": false,
        "sha": "ac7d00d1e5b8c38d7f68f46e86197e474a6cf57cffb0587ddeb6775c8ed445d9",
        "origen": "Sample JSON"
      },
      {
        "id": "f15b1430-0e95-11f1-8047-e7c13ea114ef",
        "name": "playa2.pdf",
        "currentDescription": "playa2.pdf",
        "mime": "application/pdf",
        "date": "2026-02-20 16:02:21",
        "path": "febos-io/chile/escritorio-digital/desarrollo/archivos/expedientes/1771617258739f15b1430-0e95-11f1-8047-e7c13ea114ef.pdf",
        "failed": false,
        "sha": "a0977264a1897c7f1c9b0b6010d9988a59e844cc53f961fab5001d11f32886fc",
        "origen": "Sample without type & extension"
      }
    ],
    "status": "3",
    "numero": "0",
    "documentType": "SCH",
    "company": "1ed6c060-9df0-46e3-b7f1-4b2ee3782e84",
    "companyName": "Universidad de Aysén",
    "createdBy": "83703bf0-c9c5-4b8f-b5de-e556651dbf6c",
    "createdName": "Letty Villamizare",
    "createdAt": "2026-02-20T16:54:45.970166",
    "trackingId": "b0f04260-3dab-417a-a260-b8cb94f36f7b",
    "locationId": "bf335486-9031-4ca5-a06f-19309ea73a56",
    "locationType": "root"
  },
  "name": "SCH (No docente) - Bato gatindo - 20-02-2026 16:54:45.pdf",
  "codigo": 10,
  "mensaje": "Acción realizada satisfactoriamente",
  "hora": "2026-02-20 16:54:46",
  "seguimientoId": "b0f04260-3dab-417a-a260-b8cb94f36f7b",
  "duracion": 924
};

// GRC
